import { FinancingLoanType, PAGE } from '@/constants/common';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FormTypes } from '.';
import {
  PledgeUnpledgeCombination,
  PropertySubType,
  PropertyType,
  MEDIUM_TERM_INTEREST_RATE,
  RESIDENTIAL_CONDO_65_DATA,
} from '@/constants/others/pledge-unpledge';

export const initialState = {
  formField: {
    profiles: [
      {
        name: 'Profile A',
        age: 35,
        monthlyFixedIncome: 0,
        monthlyVariableIncome: 0,
        monthlyExpenses: 0,
      },
    ],
    propertyType: PropertyType.RESIDENTIAL,
    propertySubType: PropertySubType.CONDO_LANDED,
    estimatedPropertyValuation: 0,
    financingLoanType: FinancingLoanType.sixtyFiveYearLoan,
    mediumTermInterestRate: MEDIUM_TERM_INTEREST_RATE.DEFAULT,
    loanToValue: RESIDENTIAL_CONDO_65_DATA.LOAN_TO_VALUE.DEFAULT,
    loanTenure: RESIDENTIAL_CONDO_65_DATA.LOAN_TENURE.DEFAULT,
    hasCombination: PledgeUnpledgeCombination.NO,
    pledgeAmount: 0,
  } as FormTypes,
  loading: true,
  from: '' as PAGE | '',
};

export const pledgeUnpledgeSlice = createSlice({
  name: 'pledgeUnpledge',
  initialState,
  reducers: {
    updateDataForm: (
      state,
      action: PayloadAction<
        FormTypes & {
          from: PAGE | '';
        }
      >,
    ) => {
      const { from, ...rest } = action.payload;

      state.formField = rest;
      state.from = action.payload.from;
    },
    updateFrom: (state, action: PayloadAction<PAGE>) => {
      state.from = action.payload;
    },
    reset: () => {
      return initialState;
    },
  },
});

export const { updateDataForm, updateFrom, reset } = pledgeUnpledgeSlice.actions;

export default pledgeUnpledgeSlice.reducer;
